/* eslint-disable import/no-unresolved */
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import { config } from '../../../config';
import { A } from '../A';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { BREAKPOINTS } from '../../Constants';

export const ColumnSlider = ({ parent, items, extraClasses }) => {
  const maxSlides = parent === 'opRegions' ? 3 : 4;

  const breakpoints = {
    0: {
      slidesPerView: 1,
    },
    [BREAKPOINTS.sm]: {
      slidesPerView: 2,
    },
    [BREAKPOINTS.md]: {
      slidesPerView: 3,
    },
    [BREAKPOINTS.lg]: {
      slidesPerView: maxSlides,
    },
  };

  const sliderItems = items.map((item, index) => {
    const cardImage = (
      <div className="position-relative">
        <Card.Img className={`img-fluid ${extraClasses}`} src={item.image} alt={item.title} loading="lazy" />
        {item.overlay_text?.length > 0 && (
          <div className="column-text-overlay p-2 text-white text-uppercase w-100 font-weight-bold">
            {item.overlay_text}
          </div>
        )}
      </div>
    );

    const CardContent = (
      <>
        {cardImage}
        <Card.Body>
          <h3 className={`h5 text-${config['global.textHighlight']}`}>{item.title}</h3>
          <p className="m-0 text-darker">{item.text}</p>
        </Card.Body>
      </>
    );

    return (
      <SwiperSlide key={index}>
        <Card>
          <CardLinkWrapper url={item.url} title={item.title}>
            {CardContent}
          </CardLinkWrapper>
        </Card>
      </SwiperSlide>
    );
  });

  return (
    <Swiper
      modules={[Navigation]}
      navigation
      spaceBetween={16}
      loop
      breakpoints={breakpoints}
      className="homepage-slide"
    >
      {sliderItems}
    </Swiper>
  );
};

const CardLinkWrapper = ({ url, title = '', children }) => {
  const isExternal = /^http/.test(url);
  const commonProps = {
    className: 'd-block text-decoration-none outline-none w-100 h-100',
    title,
  };

  return isExternal ? (
    <A href={url} {...commonProps}>
      {children}
    </A>
  ) : (
    <Link to={url} {...commonProps}>
      {children}
    </Link>
  );
};
